import type { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SkipLink from "./SkipLink";

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <SkipLink />
    <Navbar />
    <main id="main-content" tabIndex={-1} className="flex-1 page-enter">
      {children}
    </main>
    <Footer />
  </div>
);

export default Layout;
